import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'pegasus-banner',
  standalone: true,
  imports: [CommonModule, NgbCarouselModule],
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
})
export class BannerComponent {
  @Input() banners: string[] = [];
  showNavigationArrows = false;
  showNavigationIndicators = false;
}
